import React, {useState,useEffect} from 'react'
import * as b from 'react-bootstrap'
import axios from 'axios'
import { faPaperPlane, faRedoAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import aboutdata from "./page1.data.json";

function UpdateHome() {
    const [links,setLinks]=useState({image:"",video:""})
    const [submit,setSubmit]=useState(false)
    const [resultBar,SetResultBar]=useState(false)
    const [spin, setSpin] = useState(false)
    const [reload, setReload] = useState(true)
    const [about, setAbout] = useState(aboutdata)
    const [newabout, setNewAbout] = useState(aboutdata)
    
    useEffect(()=>{
        if (reload) {
            axios.get('https://lime-rich-spider.cyclic.app/api/v1/Home/About')
            .then(response =>{
                // console.log(response.data.data.about[0])
               // console.log(response)
                let allabout = JSON.parse(JSON.stringify(response.data.data.about[0]));
                setAbout(allabout)
                setNewAbout(response.data.data.about[0])
                vidimg()
                // this.props.update(response.data.data.events)
            })
            .catch(error => {
                console.log(error)
            })
            setReload(false)
            setSpin(false)
        }
        if (submit) {
            // console.log(info)
            const proxyurl = "https://cors-anywhere.herokuapp.com/";
            setSpin(<b.Spinner animation="border" variant="success" />)
            console.log('posting now')
            axios.patch('https://lime-rich-spider.cyclic.app/api/v1/Home/About/'+String(about._id),newabout)
                    .then(response =>{
                        console.log(response.data.data.about)
                        // Reset()
                        SetResultBar(<b.Alert key={1} variant="success"><h5>Home page Successfully Updated</h5></b.Alert>)
                        setReload(true)
                    })
                    .catch(error => {
                        console.log(error.response)
                        Reset()
                        SetResultBar(<b.Alert key={0} variant="danger"><h5>Error Occured in Pushing Data</h5></b.Alert>)
                        setSpin(false)
                    })  
            setSubmit(false)
            
        }
        
    },[submit,links,reload])
    
    function validate(){
        let dataimages=[]
        let datavideos=[]
        if (newabout.Contact!==""&&newabout.Email!==""&&newabout.Instagram!==""&&newabout.Linkedin!==""&&newabout.facebook!=="") {
          // console.log("true man")
          // console.log(props)
        //   console.log(data)
          dataimages=links.image.split("\n")
          dataimages = dataimages.map((link,index) => {
              return(
                  {
                      name:String(index)+".jpg",
                      url:link 
                  }
              )
          })
          datavideos=links.video.split("\n")
          datavideos = datavideos.map((link)=>{
              return(
                  {
                      url:link
                  }
              )
          })
        //   console.log(datavideos);
        //   console.log(dataimages);
        //   setCred({...data,images:dataimages,videoLinks:datavideos})
          setNewAbout({...newabout,photos:dataimages,videos:datavideos})
          console.log(newabout)
          setSubmit(true)
        //   console.log(data)
        }
        else{
            SetResultBar(<b.Alert key={2} variant="danger"><h5>Text field is Blank. Kindly fill</h5></b.Alert>)
        }
    }

    function Reset(){
        let allabout = JSON.parse(JSON.stringify(about));
        setNewAbout(allabout)
        // setLinks({image:"",video:""})
        vidimg()
        setSubmit(false)
        SetResultBar(false)
    }

    const vidimg = () =>{
        let imglist = newabout.photos.map(img => {
            return( img.url )
        })
        let imgs = imglist.join("\n")
        // console.log(imgs);
        let vidlist = newabout.videos.map(vid => {
            return( vid.url )
        })
        let vids = vidlist.join("\n")
        // console.log(vids);
        setLinks({image:imgs,video:vids})

    }

    const handleChangeInput=(e,attr,index)=>{
        const values = {...newabout};
        if (attr==="body") {
            values.para[index].body=e.target.value
        }
        else if (attr==="title") {
            values.para[index].title=e.target.value
        }
        setNewAbout(values)
    }
    return (
        <div>
            <h1>Update Home Page</h1><br/>
            <h4>Update Contact Number</h4>
            <input type='tel' value={newabout.Contact} style={{width:"98%", height:"35px"}} onChange={e=>setNewAbout({...newabout,Contact: e.target.value})}></input><br/><br/>
            <h4>Update Email Id</h4>
            <input type='email' value={newabout.Email} style={{width:"98%", height:"35px"}} onChange={e=>setNewAbout({...newabout,Email: e.target.value})}></input><br/><br/>
            <h4>Update Linkedin URL</h4>
            <input type='url' value={newabout.Linkedin} style={{width:"98%", height:"35px"}} onChange={e=>setNewAbout({...newabout,Linkedin: e.target.value})}></input><br/><br/>
            <h4>Update Facebook URl</h4>
            <input type='url' value={newabout.facebook} style={{width:"98%", height:"35px"}} onChange={e=>setNewAbout({...newabout,facebook: e.target.value})}></input><br/><br/>
            <h4>Update Instagram</h4>
            <input type='url' value={newabout.Instagram} style={{width:"98%", height:"35px"}} onChange={e=>setNewAbout({...newabout,Instagram: e.target.value})}></input><br/><br/>
            
            <h3>Paragraph Details</h3>
            {newabout.para.map((obj,index)=>{
                return(
                <div>
                    <h4>Paragraph {index+1} Title</h4>
                    <input type='text' value={newabout.para[index].title} style={{width:"98%", height:"35px"}} onChange={e=>handleChangeInput(e,"title",index)}></input><br/><br/>
                     <h4>Paragraph {index+1} Description</h4>
                    <textarea value={newabout.para[index].body} style={{width:"98%", height:"100px"}} onChange={e=>handleChangeInput(e,"body",index)}></textarea><br/><br/>
                </div>
                )
            })}
            {/* <input type='text' value={data.cardImage} style={{width:"98%", height:"35px"}} onChange={e=>setCred({...data,cardImage: e.target.value})}></input><br/><br/>
            <h4>Add Event Description</h4>
            <textarea value={data.description} style={{width:"98%", height:"100px"}} onChange={e=>setCred({...data,description: e.target.value})}></textarea><br/><br/>
            <h4>Add Event Thumbnail Link</h4>
            <input type='text' value={data.cardImage} style={{width:"98%", height:"35px"}} onChange={e=>setCred({...data,cardImage: e.target.value})}></input><br/><br/>
            <h4>Add Event Date</h4>
            <input type='text' value={data.date} style={{width:"98%", height:"35px"}} onChange={e=>setCred({...data,date: e.target.value})}></input><br/><br/> */}
            <h4>Home Image Links</h4>
            <textarea value={links.image} style={{width:"98%", height:"200px"}} onChange={e=>setLinks({...links,image: e.target.value})}></textarea><br/><br/>
            <h4>Home Video Links</h4>
            <textarea value={links.video} style={{width:"98%", height:"200px"}} onChange={e=>setLinks({...links,video: e.target.value})}></textarea>
            <br/>
            {resultBar}
            <br/><br/>
            <b.Button variant="danger" style={{margin:"10px"}} onClick={()=>{
                Reset();
            }}>Reset  <FontAwesomeIcon icon={faRedoAlt}/></b.Button>

            <b.Button variant="success" style={{margin:"10px"}} onClick={()=>{
                validate()
            }}>Submit    <FontAwesomeIcon icon={faPaperPlane}/></b.Button> {spin}
            <br/><br/>
            <br/><br/>
        </div>
    )
}

export default UpdateHome
